var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorStatusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.06374 11.4547C7.93101 11.4547 7.80127 11.4941 7.69092 11.5678C7.58056 11.6416 7.49455 11.7464 7.44376 11.869C7.39297 11.9916 7.37968 12.1265 7.40557 12.2567C7.43146 12.3869 7.49538 12.5065 7.58922 12.6003C7.68307 12.6942 7.80265 12.7581 7.93282 12.784C8.06299 12.8099 8.19792 12.7966 8.32054 12.7458C8.44316 12.695 8.54797 12.609 8.6217 12.4986C8.69544 12.3883 8.7348 12.2585 8.7348 12.1258C8.7348 11.9478 8.6641 11.7771 8.53825 11.6513C8.4124 11.5254 8.24171 11.4547 8.06374 11.4547Z",
    fill: "#B246C2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.06374 3.9053C8.3417 3.9053 8.56703 4.13063 8.56703 4.40859V9.44155C8.56703 9.71952 8.3417 9.94485 8.06374 9.94485C7.78577 9.94485 7.56044 9.71952 7.56044 9.44155V4.40859C7.56044 4.13063 7.78577 3.9053 8.06374 3.9053Z",
    fill: "#B246C2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.755989 11.5913L5.96794 1.28872C6.83704 -0.429249 9.29043 -0.429247 10.1595 1.28872L15.3715 11.5913C16.1618 13.1536 15.0265 15.0002 13.2757 15.0002H2.85178C1.10096 15.0002 -0.0343515 13.1536 0.755989 11.5913ZM6.86614 1.74311C7.36277 0.761412 8.76471 0.761412 9.26133 1.74311L14.4733 12.0457C14.9249 12.9384 14.2762 13.9937 13.2757 13.9937H2.85178C1.85132 13.9937 1.20256 12.9384 1.65419 12.0457L6.86614 1.74311Z",
    fill: "#B246C2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorStatusIcon);
export default __webpack_public_path__ + "static/media/error_status_icon.2d5d71d9d010d06750187a6d4ae9fb87.svg";
export { ForwardRef as ReactComponent };